export default __webpack_public_path__ + "static/media/6-OJMCNCMachining.6d1ba69c.png";